import { render, staticRenderFns } from "./RosterLocationNuPointSpray.vue?vue&type=template&id=2c10d7c3&scoped=true&"
import script from "./RosterLocationNuPointSpray.vue?vue&type=script&lang=js&"
export * from "./RosterLocationNuPointSpray.vue?vue&type=script&lang=js&"
import style0 from "./RosterLocationNuPointSpray.vue?vue&type=style&index=0&id=2c10d7c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10d7c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VChip,VImg,VTooltip})
